// Top bar: room title + (in Phase 5) audio controls. Phase 3 wires the title only.

import type { Room } from '../app/types';

export class Topbar {
  private readonly root: HTMLElement;
  private readonly titleEl: HTMLElement;

  constructor() {
    const root = document.getElementById('topbar');
    const title = document.getElementById('room-title');
    if (!root || !title) throw new Error('[topbar] missing DOM');
    this.root = root;
    this.titleEl = title;
  }

  show(): void {
    this.root.classList.remove('hidden');
  }

  setRoom(room: Room): void {
    this.titleEl.textContent = room.name;
  }
}
